
/* START_TEMPLATE */
define('hbs!pricelist/templates/node-header',['hbs','handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
helpers = helpers || Handlebars.helpers;
  var stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n    ";
  stack1 = helpers['if'].call(depth0, depth0.isFormat, {hash:{},inverse:self.program(5, program5, data),fn:self.program(2, program2, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n	    <table class=\"";
  if (stack1 = helpers['class']) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0['class']; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + " selectable\" style=\"border-collapse:separate\">\r\n            <tr style=\"border-collapse:separate\">\r\n                <td>\r\n                    ";
  if (stack1 = helpers.name) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.name; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "\r\n                </td>\r\n                <td>\r\n                    <div style=\"display:inline-block; width:60%\">";
  if (stack1 = helpers.name) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.name; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</div>\r\n                    ";
  stack1 = helpers.unless.call(depth0, depth0.isPrint, {hash:{},inverse:self.noop,fn:self.program(3, program3, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n                </td>\r\n            </tr>\r\n        </table>\r\n    ";
  return buffer;
  }
function program3(depth0,data) {
  
  
  return "\r\n                        <img style=\"vertical-align:top\" src=\"/Content/images/IAB_bara_small.png\" />\r\n                    ";
  }

function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n        <div class=\"";
  if (stack1 = helpers['class']) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0['class']; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (stack1 = helpers.name) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.name; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</div>\r\n    ";
  return buffer;
  }

  stack1 = helpers.each.call(depth0, depth0.head, {hash:{},inverse:self.noop,fn:self.program(1, program1, data)});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  });
Handlebars.registerPartial('pricelist_templates_node-header', t);
return t;
});
/* END_TEMPLATE */
;
